export default <template>{{outlet}}</template>
